export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Donate-Gray-5f1b555cf662d052e6396009b2e68b59.svg";